/**
 * chartCapture.js - Capture chart DOM elements as PNG images for export
 * Uses html-to-image (SVG foreignObject) to capture rendered chart components.
 * html-to-image uses the browser's native CSS engine, supporting modern CSS
 * features like oklch() colors that html2canvas cannot parse.
 */

import { toCanvas } from 'html-to-image';

/**
 * Capture all chart elements matching [id^="export-chart-"] and return a Map of name -> base64 PNG.
 * @param {HTMLElement} container - The container element holding all chart divs
 * @returns {Promise<Object>} Object mapping chart names to base64 PNG data URLs
 */
export async function captureAllCharts(container) {
  const chartDivs = container.querySelectorAll('[id^="export-chart-"]');
  const chartImages = {};

  console.log(`[chartCapture] Found ${chartDivs.length} chart elements in container`);

  for (const div of chartDivs) {
    const name = div.id.replace('export-chart-', '');

    console.log(`[chartCapture] ${name}: offsetHeight=${div.offsetHeight}, children=${div.children.length}`);

    // Skip empty containers (chart returned null or has no visible content)
    if (div.offsetHeight < 10 || div.children.length === 0) {
      console.log(`[chartCapture] SKIPPING ${name} (height<10 or no children)`);
      continue;
    }

    try {
      const canvas = await toCanvas(div, {
        pixelRatio: 2, // 2x for crisp output
        backgroundColor: '#ffffff',
      });

      console.log(`[chartCapture] CAPTURED ${name}: ${canvas.width}x${canvas.height}`);

      chartImages[name] = {
        dataUrl: canvas.toDataURL('image/png'),
        width: canvas.width,
        height: canvas.height,
      };
    } catch (err) {
      console.warn(`[chartCapture] FAILED to capture "${name}":`, err);
    }
  }

  console.log(`[chartCapture] Final: ${Object.keys(chartImages).length} charts captured:`, Object.keys(chartImages));

  return chartImages;
}
